import React from 'react';

/**
 * Candidate-facing feedback body. Rows written by the server-side composer carry structured
 * sections (strengths, improvements, technical / communication feedback, next steps); legacy
 * rows only have text, which the server has already cleaned of placeholders and integrity rows.
 * Nothing is invented here: no sample strengths, no default verdict.
 */
export default function FeedbackBody({ feedback, compact = false }) {
  if (!feedback) return null;
  const structured = Array.isArray(feedback.strengths) || Array.isArray(feedback.improvements);
  const text = feedback.feedbackText || feedback.emailBody || '';
  const small = compact ? 'text-xs' : 'text-sm';

  if (!structured) {
    return text ? (
      <p className={`${small} text-[var(--ink-soft)] leading-relaxed whitespace-pre-wrap`}>{text}</p>
    ) : null;
  }

  const list = (title, items) => (Array.isArray(items) && items.length > 0 ? (
    <div>
      <p className="text-[11px] font-semibold uppercase tracking-wider text-[var(--ink-faint)] mb-1">{title}</p>
      <ul className={`${small} text-[var(--ink-soft)] leading-relaxed space-y-1 list-disc pl-4`}>
        {items.map((s, i) => <li key={i}>{s}</li>)}
      </ul>
    </div>
  ) : null);
  const para = (title, value) => (value ? (
    <div>
      <p className="text-[11px] font-semibold uppercase tracking-wider text-[var(--ink-faint)] mb-1">{title}</p>
      <p className={`${small} text-[var(--ink-soft)] leading-relaxed`}>{value}</p>
    </div>
  ) : null);
  const practice = feedback.mode === 'PRACTICE';

  return (
    <div className="space-y-3">
      <p className="text-[11px] text-[var(--ink-faint)]">
        Interviewed by {feedback.interviewer || 'Aria'}{!practice && feedback.orgName ? ` · ${feedback.orgName}` : ''}
      </p>
      {practice && para('Overall performance', feedback.overallPerformance)}
      {list('What went well', feedback.strengths)}
      {list('What to improve', feedback.improvements)}
      {para('Technical feedback', feedback.technicalFeedback)}
      {para('Communication', feedback.communicationFeedback)}
      {!compact && list(practice ? 'Next practice focus' : 'Suggested next steps', feedback.nextSteps)}
    </div>
  );
}
